import { Component, OnDestroy, OnInit } from '@angular/core';
import { ProjectsVisibilityGroupResponse } from '../../models/response/projects-visibility-group-response-input.model';
import { AccountConfigurationService } from '../../services/account-configuration.service';
import { MatLegacyDialog as MatDialog } from "@angular/material/legacy-dialog";
import { ProjectVisibilityDialogComponent } from '../create-group-visibility-dialog/project-visibility-dialog.component';
import { MessageDialogModalDialog } from '../errors-dialog/message-dialog-modal';
import { NotificationService } from '../../services/notification-service';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import DialogDataDto from '../../models/new-file-dialog-dto';
import { AccountContextService } from 'src/app/authentication/services/account-context.service';

@Component({
  selector: 'project-visibility-group',
  templateUrl: './project-visibility-group.component.html',
  styleUrls: ['./project-visibility-group.component.scss']
})
export class ProjectVisibilityGroupComponent implements OnInit, OnDestroy {

  private notifySubscription: Subscription;
  private destroy$ = new Subject<void>();
  dataSourceVisibilityGroup: ProjectsVisibilityGroupResponse[] = [];
  displayedColumnsGroupVisibility: string[] = ['groupVisibility', 'actions'];

  constructor(
    private accountConfigurationService: AccountConfigurationService,
    public dialog: MatDialog,
    private notificationService: NotificationService,
    private accountContext: AccountContextService) {

  }

  ngOnDestroy(): void {
    this.notifySubscription?.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {
    this.notifySubscription = this.notificationService.notify
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
      this.reloadData();
    });

    this.loadGroups();
  }

  private loadGroups(): void {
    const account = this.accountContext.getSelectedAccountId();

    if (!account) {
      this.dataSourceVisibilityGroup = [];
      return;
    }

    this.accountConfigurationService.getProjectsVisibilityGroup(account)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
      next: (data) => {
        this.dataSourceVisibilityGroup = data;
      },
      error: (error) => {
        console.error(error);
      }
    });
  }

  async onClickNewConfiguration(): Promise<void> {
    const dialogData = new DialogDataDto(null, this.getEmailList());
    this.dialog.open(ProjectVisibilityDialogComponent, {
      data: dialogData
    })
  }

  editVisibilityGroup(dataSourceVisibilityGroup: ProjectsVisibilityGroupResponse) {
    if (dataSourceVisibilityGroup) {
      const dialogData = new DialogDataDto(dataSourceVisibilityGroup, this.getEmailList());
      this.dialog.open(ProjectVisibilityDialogComponent, {
        data: dialogData
      });
    }
  }

  deleteVisibilityGroup(id: string) {
    const account = this.accountContext.getSelectedAccountId();

    if (!account) {
      return;
    }

    const dialogRef = this.dialog.open(MessageDialogModalDialog, {
      data: {
        title: "visibility.messages.alertTitle",
        message: "visibility.messages.deleteMessage",
        isError: false,
        isConfirmDialog: true
      }
    });

    dialogRef.afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe(confirm => {
      if (!confirm)
        return;

      this.accountConfigurationService.deleteProjectsVisibilityGroup(account, id)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
        next: () => {
          this.reloadData();
        },
        error: (error) => {
          if (error.status == 400) {
            this.dialog.open(MessageDialogModalDialog, {
              data: {
                title: "visibility.messages.alertTitle",
                message: "visibilityRequest.errors.userIsNotAnAccountAdministrator",
                isError: true
              }
            });
          }
          if (error.status == 500) {
            this.dialog.open(MessageDialogModalDialog, {
              data: {
                title: "visibility.messages.alertTitle",
                message: "visibilityRequest.errors.errorOnDelete",
                isError: true
              }
            });
          }
        }  
      });
    });
  }

  reloadData() {
    this.dataSourceVisibilityGroup = [];
    this.loadGroups();
  }

  getEmailList(): string[] {
    const emails: string[] = this.dataSourceVisibilityGroup
      .reduce((accumulator, data) => accumulator.concat(data.Users), []);

    return emails;
  }
}
